var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.8C19.4756 2.8 19.05 3.22557 19.05 3.75002V23.25C19.05 23.7745 19.4756 24.2 20 24.2C20.5245 24.2 20.95 23.7745 20.95 23.25V3.75002C20.95 3.22557 20.5245 2.8 20 2.8Z",
    fill: "#D42124",
    stroke: "#D42124",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3801 8.63625L26.3801 8.63624L26.3791 8.63582C25.8992 8.42906 25.3409 8.64698 25.13 9.12588L25.1299 9.12614C24.9189 9.607 25.1393 10.1676 25.6199 10.3767C30.7417 12.616 34.05 17.6681 34.05 23.2495C34.05 30.996 27.7465 37.2995 20 37.2995C12.2535 37.2995 5.94998 30.9961 5.94998 23.2495C5.94998 17.6682 9.25823 12.6161 14.3799 10.3769C14.8605 10.1678 15.081 9.60743 14.8703 9.12655C14.6607 8.64657 14.1019 8.42945 13.6211 8.63578L13.6211 8.63577L13.6199 8.63631C7.80669 11.1775 4.05 16.9119 4.05 23.2495C4.05 32.045 11.2045 39.1995 20 39.1995C28.7955 39.1995 35.95 32.045 35.95 23.2495C35.95 16.9119 32.1933 11.1775 26.3801 8.63625Z",
    fill: "#D42124",
    stroke: "#D42124",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout1);
export default __webpack_public_path__ + "static/media/logout-1.cb6662b49e87a16bb5a7727febc3316e.svg";
export { ForwardRef as ReactComponent };